module.exports = __webpack_public_path__ + "static/media/emptystate-notification.c6b78b3d.svg";